const getDefaultState_Transcribe = () => {
  return {
    selectedPhrase: null,
    selectedDictionary: null,
    phrases: [],
  }
}
const state = getDefaultState_Transcribe();

const getters = {
  selectedPhrase: state => state.selectedPhrase,
  selectedDictionary: state => state.selectedDictionary,
  phrases: state => state.phrases,
}

const actions = {
  changeSelectedDictionary({state, commit}, dictionary) {
    commit('SET_SELECTED_DICTIONARY', dictionary);
    if (dictionary !== state.selectedDictionary) {
      commit('SET_SELECTED_DICTIONARY', dictionary)
      commit('SET_SELECTED_PHRASE', null);
    }
  },

  changeSelectedPhrase({state, commit}) {
    let phrase = null;
    let index = state.selectedDictionary['words'].indexOf(state.selectedPhrase);
    if (index !== -1) {
      index++;
    } else {
      index = 0;
    }

    if (index > state.selectedDictionary['words'].length - 1) {
      index = 0;
    }

    phrase = state.selectedDictionary['words'][index];

    commit('SET_SELECTED_PHRASE', phrase);
  },

  changePhrases({commit}, phrases = []) {
    commit('SET_PHRASES', phrases);
  },
}

const mutations = {
  SET_SELECTED_DICTIONARY(state, value) {
    state.selectedDictionary = value;
  },

  SET_SELECTED_PHRASE(state, value) {
    state.selectedPhrase = value;
  },

  SET_PHRASES(state, value) {
    state.phrases = value;
  },


  RESET_STATE_TRANSCRIBE (state) {
    Object.assign(state, getDefaultState_Transcribe())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
